import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=0c4f76ae&scoped=true"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=0c4f76ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4f76ae",
  null
  
)

export default component.exports